import { EActivityEventType, EOrganizedBy } from 'detailsv2/structure';
import yup from 'utils/yup';

import { wrongTimeFormatError } from '../../constants';
import { optionalTimeFormatValidation, optionalTimeLengthValidation } from '../../functions';

export const activityValidationSchema = (organizedBy: EOrganizedBy) => {
  const formFields: any = {
    data: yup.object().shape({
      title: yup.string().required('Title is required'),
      type: yup.string().required('Please select activity type'),
      time: yup.object().shape({
        start: yup
          .string()
          .test('start-time-len', wrongTimeFormatError, optionalTimeLengthValidation)
          .test('is-start-time-valid', wrongTimeFormatError, optionalTimeFormatValidation),
        end: yup
          .string()
          .test('end-time-len', wrongTimeFormatError, optionalTimeLengthValidation)
          .test('is-end-time-valid', wrongTimeFormatError, optionalTimeFormatValidation),
      }),
      website: yup.string().trim().websiteURL(),
    }),
    attachedPages: yup.array().min(1, 'Please add an Activity'),
  };

  if (organizedBy === EOrganizedBy.Date) {
    formFields.datesRange = yup.object().shape({
      start: yup.string().required('Please fill in this field').nullable(),
      end: yup.string().requiredIfMultiDate().nullable(),
    });
  }

  if (organizedBy === EOrganizedBy.Day) {
    formFields.daysRange = yup.object().shape({
      start: yup.number().required('Please fill in this field').nullable(),
      end: yup.number().requiredIfMultiDay().nullable(),
    });
  }

  return yup.object().shape({
    ...formFields,
  });
};

yup.addMethod(yup.string, 'requiredIfMultiDate', function (this: any) {
  return this.test({
    message: 'Must be longer than one day',
    name: 'testEndDate',
    test: function (this: any, value: string) {
      const start = this.parent.start;
      const type = this.from[1].value.data.type;
      if (type === EActivityEventType.MultiDay && start === value) {
        return false;
      }

      return (type === EActivityEventType.MultiDay && value !== null) || type !== EActivityEventType.MultiDay;
    },
  });
});

yup.addMethod(yup.number, 'requiredIfMultiDay', function (this: any) {
  return this.test({
    message: 'Must be longer than one day',
    name: 'testEndDay',
    test: function (this: any, value: number) {
      const start = this.parent.start;
      const type = this.from[1].value.data.type;
      if (type === EActivityEventType.MultiDay && value === start) {
        return false;
      }

      return (type === EActivityEventType.MultiDay && value !== null) || type !== EActivityEventType.MultiDay;
    },
  });
});
